import React from 'react';
import classes from './PatientInfo.module.css';
import { SalesOrderInfo } from '../../../store/slices/salesOrders';
import { useAppDispatch, useAppSelector } from '../../../store/store';
import { fetchCustomers, ICustomer, selectCustomers } from '../../../store/slices/customers';
import { CustomerInfo } from '../../../components/CustomerInfo/CustomerInfo';

const PatientInfo: React.FC<{ selectedSalesOrder: SalesOrderInfo }> = ({ selectedSalesOrder }) => {
  const dispatch = useAppDispatch();
  const customers: ICustomer[] = useAppSelector<ICustomer[]>(selectCustomers);

  React.useEffect(() => {
    dispatch(fetchCustomers());
  }, [dispatch]);

  const customer: ICustomer | undefined = React.useMemo(() => {
    return customers.find(
      (customer) => customer.person_id == selectedSalesOrder?.customer_person?.person_id
    );
  }, [selectedSalesOrder.customer_person?.person_id, customers]);

  if (!customer) {
    return <></>;
  }

  return (
    <div className={classes.container}>
      <CustomerInfo customer={customer} />
    </div>
  );
};

export { PatientInfo };
